// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleSmall_container__MWLnI","icon":"ArticleSmall_icon__rh3r3","divider":"ArticleSmall_divider__GBk1P"};